export default __webpack_public_path__ + "static/media/gallery_10.fe21d95e.jpg";